import { Shield } from "lucide-react"
import { PlaceholderPage } from "./placeholder-page"

export function GroupsSettingsPage() {
  return (
    <PlaceholderPage
      icon={Shield}
      title="Grupy"
      description="Tw\u00F3rz i zarz\u0105dzaj grupami u\u017Cytkownik\u00F3w \u2014 przypisuj cz\u0142onk\u00F3w i definiuj role w zespole."
    />
  )
}
